import { FC } from 'react';

const TrailerColumn: FC = () => {
  return (
    <div className="d-flex flex-column g-inherit">
      <p className="text-primary-dark font-weight-bold">CHASSIS</p>
      <div className="text-field">
        <input className="w-100" defaultValue="TRAILER" disabled />
        <label>UNIT NUMBER</label>
      </div>
      <div className="text-field">
        <input className="blank w-100" disabled />
        <label>SIZE TYPE</label>
      </div>
      <div className="text-field">
        <input className="blank w-100" disabled />
        <label>ACCOUNT</label>
      </div>
      <div className="text-field" style={{ maxHeight: 42 }}>
        <input className="blank w-100" disabled />
        <label>STATUS</label>
      </div>
      <div className="text-field">
        <input className="blank w-100" disabled />
        <label>BOOKING</label>
      </div>
      <div className="text-field">
        <input className="blank w-100" disabled />
        <label>REDELIVERY NUMBER</label>
      </div>
      <div className="checkboxes d-flex g-2 justify-content-center">
        <label className="font-weight-bold">TRAILER</label>
        <input type="checkbox" defaultChecked disabled />
      </div>
    </div>
  );
};

export default TrailerColumn;
